module.exports = __webpack_public_path__ + "img/hyatt-2.6b9ecd70.png";